import { createClient } from "next-sanity"

export const client = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || "production",
  apiVersion: "2024-12-01",
  useCdn: false,
  // token: sanityViewerToken, removed for sanity live configuration
  stega: {
    studioUrl: "https://cm.devpunks.com/",
  },
})
